import { useQuery } from '@tanstack/react-query';
import { getExecutionProgressTrackings } from 'api/executionProgressTrackings';
import { executionProgressTrackingsKeys } from 'api/queryKeys';
import { useMainCompanyQuery } from './useMainCompanyQuery';

export const useExecutionProgressTrackingsQuery = () => {
  const { data: mainCompany } = useMainCompanyQuery();
  const companyId = mainCompany?.id ?? '';

  return useQuery({
    queryKey: executionProgressTrackingsKeys.list(companyId),
    queryFn: () =>
      getExecutionProgressTrackings().then((res) => res.data ?? []),
    enabled: !!companyId
  });
};
